import {createRouter, createWebHistory} from 'vue-router';
import auth from '@/commons/authService';
import routerTreasury from './routerTreasury.js';
import routerDemo from './routerDemo.js';
import routerPage from './routerPage.js';
import routerBudgetPlan from './routerBudgetPlan.js';
import routerEtreasury from './routerEtreasury.js';
import routerCash from './routerCash.js';
import routerDeposits from './routerDeposits.js';
import commonFn from '@/commons/commonFunction.js';
import popupUtil from '@/commons/popupUtil.js';
import dictionary from './routerDI.js';
import routerFixedAsset from './routerFA.js';
import routerInvoice from './routerInvoice.js';
import routerTools from './routerTools.js';
import routerSummary from './routerSummary.js';
import routerConnect from './routerConnect.js';
import routerReceipt from './routerReceipt';
import routerReport from './routerReport.js';
import routerSystem from './routerSystem.js';
import routerSetting from './routerSetting.js';
import routerSalary from './routerSalary.js';
import routerChooseFinanceReportSetting from './routerChooseFinanceReportSetting.js';
import routerInitialInformationDeclaration from './routerInitialInformationDeclaration.js';
import routerDashboard from './routerDashboard.js';
import routerExpert from './routerExpert.js';
import routerExaminationResults from './routerExaminationResults.js';
import routerSettlementInstructions from './routerSettlementInstructions.js';
import routerUsefulKnowledge from './routerUsefulKnowledge.js';
import {useContextStore} from '@/stores/contextStore';

const routes = [
  {
    path: '',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: {
      // anonymous: true
    },
    children: [
      // default home
      {
        path: '',
        redirect: '/etreasury',
        meta: {
          defaultHomePath: true,
        },
      },
      ...routerTreasury,
      ...routerDemo,
      ...routerBudgetPlan,
      ...routerEtreasury,
      ...routerCash,
      ...dictionary,
      ...routerDeposits,
      ...routerFixedAsset,
      ...routerInvoice,
      ...routerTools,
      ...routerSummary,
      ...routerConnect,
      ...routerReceipt,
      ...routerReport,
      ...routerSystem,
      ...routerSetting,
      ...routerChooseFinanceReportSetting,
      ...routerSalary,
      ...routerInitialInformationDeclaration,
      ...routerDashboard,
      ...routerExpert,
      ...routerExaminationResults,
      ...routerSettlementInstructions,
      ...routerUsefulKnowledge,
    ],
  },
  ...routerPage,
  {
    // Redirect to 404 page, if no match found
    path: '/:pathMatch(.*)*',
    component: () => import(/* webpackChunkName:'pages'*/ '@/pages/404.vue'),
    meta: {
      anonymous: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach(() => {
  commonFn.unmask();
});

router.beforeEach((toRouter, from, next) => {
  // kiểm tra xem đã xác nhận thỏa thuận chưa
  if (!window._misaAgreementLib.IsActiveMisaAgreement) {
    const contextStore = useContextStore();
    delete contextStore.context?.Context?.TermsPrivacy;
  }

  let guardRouter = guardTermsPrivacy(toRouter.path);

  if (guardRouter) {
    next(guardRouter);
    return;
  }

  // khi chuyển router sẽ show maskloading cho người dùng biết xử lý
  // do tình huông tải file js chậm
  // trong after sẽ ẩn mask loading đi
  // Tạm thời dùng loading global, sau này có thể làm kiểu thanh line chạy ngay dưới address bar sau
  commonFn.mask();
  window._cacheTitlePage = [];

  // hide all popup
  // TODO => Ẩn tất cả popup ở đây
  popupUtil.hideAll();
  // trang không authen
  if (toRouter.meta.anonymous) {
    next();
    return;
  }

  // kiểm tra authen -> fail redirect login
  if (!auth.isAuthenticated()) {
    // auth.login(toRouter.path);
    // Thực hiện logout khỏi trương trình thay vì login khi check authen không thành công (nvthinh 19.04.2024)
    commonFn.logoff();
    return;
  }

  // commonFn.checkPermissionDVC(toRouter);

  // check theo quá hạn license, show thông báo và logout luôn
  if (commonFn.checkRouterExpiredDate()) {
    commonFn.checkWarningExpired();
    commonFn.unmask();
    return;
  }

  // check theo quyền hạn vai trò
  // + Nếu là đường dẫn mặc định thì check xem có quyền ko,
  //   nếu ko có quyền thì redirect đến màn hình Getting stated
  const isValid = commonFn.checkPermissionByRoute(toRouter);

  if (!isValid) {
    if (toRouter?.redirectedFrom?.meta?.defaultHomePath) {
      router.push('/initial-information-declaration');
    } else {
      location.href = '/403';
    }
  }

  // default
  next();
});

/**
 * "bảo vệ" màn hình xác nhận thỏa thuận/ chính sách
 * vqphong - 04/06/2024
 */
const guardTermsPrivacy = toRouterPath => {
  const contextStore = useContextStore();

  // nếu chưa xác nhận
  if (
    contextStore.context?.Context?.TermsPrivacy &&
    toRouterPath !== '/logout' &&
    toRouterPath !== '/login' &&
    toRouterPath !== '/terms-privacy'
  ) {
    return '/terms-privacy';
  } else if (!contextStore.context?.Context?.TermsPrivacy && toRouterPath === '/terms-privacy') {
    return '/';
  }
  return null;
};

export default router;
